import Vue from 'vue';
import Vuetify from 'vuetify';
import theme from './theme';
import 'vuetify/dist/vuetify.min.css';
import '../styles/index.scss';
import '@mdi/font/css/materialdesignicons.css';

/* Default theme:
{
    accent: "#82B1FF"
    error: "#f55a4e"
    info: "#00d3ee"
    primary: "#2a64f6"
    secondary: "#4caf50"
    success: "#5cb860"
    tertiary: "#1c1c1c"
    warning: "#c9954d"
}
*/

Vue.use(Vuetify, {
    iconfont: 'mdi',
    theme
});
